const to_snapshot = (name, parameters) => ({
  name,
  parameters
});
export const asr_transition_state = (state_router) => {
  const active = state_router.getActiveState();
  let current_state = $state(to_snapshot(active.name, active.parameters));
  let transition = $state({
    currently_transitioning: false,
    state_being_transitioned_to: null
  });
  state_router.on(`stateChangeStart`, (state, parameters) => {
    transition = {
      currently_transitioning: true,
      state_being_transitioned_to: to_snapshot(state.name, parameters)
    };
  });
  const transition_over = () => {
    transition = {
      currently_transitioning: false,
      state_being_transitioned_to: null
    };
  };
  state_router.on(`stateChangeEnd`, (state, parameters) => {
    current_state = to_snapshot(state.name, parameters);
    transition_over();
  });
  state_router.on(`stateChangeError`, transition_over);
  state_router.on(`stateChangeCancelled`, transition_over);
  state_router.on(`stateError`, transition_over);
  return {
    get current_state() {
      return current_state;
    },
    get currently_transitioning() {
      return transition.currently_transitioning;
    },
    get state_being_transitioned_to() {
      return transition.state_being_transitioned_to;
    }
  };
};
